import { render, staticRenderFns } from "./InputSigarusEditor.vue?vue&type=template&id=77cd5b47"
import script from "./InputSigarusEditor.vue?vue&type=script&lang=js"
export * from "./InputSigarusEditor.vue?vue&type=script&lang=js"
import style0 from "./InputSigarusEditor.vue?vue&type=style&index=0&id=77cd5b47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports